module.exports = __webpack_public_path__ + "static/media/car.fc3a6119.svg";